import { useQueryClient } from '@tanstack/react-query';
import { components } from 'src/generated/v1';
import { $api } from './api';

export type McpKeyStatus = components['schemas']['McpKeyStatus'];
export type McpKeyGenerated = components['schemas']['McpKeyGenerated'];

export const useMcpKeyStatusQuery = () => {
  return $api.useQuery('get', '/mcp_key/');
};

export const useMcpKeyMutations = () => {
  const queryClient = useQueryClient();

  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: ['get', '/mcp_key/'] });
  };

  const generateMutation = $api.useMutation('post', '/mcp_key/generate/', {
    onSuccess() {
      invalidate();
    },
  });

  const revokeMutation = $api.useMutation('post', '/mcp_key/revoke/', {
    onSuccess() {
      invalidate();
    },
  });

  return { generateMutation, revokeMutation };
};
